import React from 'react';
import NumberFormat from 'react-number-format';
import ValidatedInput from '../../commonComponents/util/ValidatedInput';
import Toggle from '../../commonComponents/util/Toggle';
import { validateFieldLength } from '../../../lib/utils';
import Select from '../../commonComponents/util/Select';

export default class AchAccountsTable extends React.Component {

    initialState = {
        accountUpdate: {
            achRoutingNumber: '',
            achAccountNumber: '',
            achAccountType: '',
            active: false
        },
        editAccountIndex: null,
        newAccount: false,
        dataErrors: []
    };

    constructor(props) {
        super(props);

        this.state = this.initialState;
    }

    addNewAccount = () => {
        this.setState({
            newAccount: true,
            accountUpdate: {
                ...this.state.accountUpdate,
                active: true
            }
        });
    }

    updateNewAccount = (name, value) => {
        this.setState({
            accountUpdate: {
                ...this.state.accountUpdate,
                [name]: value
            }
        });
    }

    submitAccountUpdates = () => {
        if (this.disableSubmit()) return;

        let bankAccounts = [...this.props.bankAccounts];
        if (this.state.accountUpdate.active) {
            bankAccounts = this.getBankAccountsOnSetAccountActive(this.state.editAccountIndex);
        }
        bankAccounts[this.state.editAccountIndex] = this.state.accountUpdate;

        this.props.updateBankAccounts(bankAccounts);

        this.setState(this.initialState);
    }

    submitNewAccount = () => {
        if (this.disableSubmit()) return;

        let bankAccounts = [...this.props.bankAccounts];
        if (this.state.accountUpdate.active) {
            bankAccounts = this.getBankAccountsOnSetAccountActive();
        }
        bankAccounts.push(this.state.accountUpdate);

        this.props.updateBankAccounts(bankAccounts);

        this.setState(this.initialState);
    }

    toggleAccountActive = (accountIndex, active) => {
        let bankAccounts = [...this.props.bankAccounts];
        if (active) {
            bankAccounts = this.getBankAccountsOnSetAccountActive(accountIndex);
        }

        bankAccounts[accountIndex].active = active;

        this.props.updateBankAccounts(bankAccounts);
    }

    getBankAccountsOnSetAccountActive = (accountIndex = null) => {
        const bankAccounts = [...this.props.bankAccounts];

        const otherActiveAccount = bankAccounts.find((act, index) => index !== accountIndex && act.active === true);
        if (otherActiveAccount) {
            otherActiveAccount.active = false;
        } else if (accountIndex !== null && this.state.accountUpdate.active) {
            this.setState({ accountUpdate: { ...this.state.accountUpdate, active: false } });
        }

        return bankAccounts;
    }

    validateFieldLength = (name, length, value) => {
        const isValid = validateFieldLength(length, value);

        let dataErrors = [...this.state.dataErrors];
        if (isValid)
            dataErrors = dataErrors.filter(e => e !== name);
        else
            dataErrors.push(name);
        this.setState({ dataErrors });

        return isValid;
    }

    disableSubmit = () => {
        const { accountUpdate, dataErrors } = this.state;
        
        if (dataErrors.length > 0) return true;
        
        const requiredFieldsMissing = !accountUpdate.achRoutingNumber || 
                                    accountUpdate.achRoutingNumber === '' ||
                                    !accountUpdate.achAccountNumber || 
                                    accountUpdate.achAccountNumber === '' ||
                                    !accountUpdate.achAccountType || 
                                    accountUpdate.achAccountType === '';
        
        return requiredFieldsMissing;
    }

    render() {
        const { bankAccounts, submitAttempted } = this.props;
        const { accountUpdate, newAccount, editAccountIndex } = this.state;

        const disableSubmit = this.disableSubmit();
        const addingOrEditing = newAccount || (editAccountIndex !== null);

        return <div className="full-width bank-accounts-edit">
            <label>ACH Bank Accounts</label>
            <span className={`link-text small-text ${addingOrEditing ? "disabled" : ""}`} style={{ fontSize: "11px", marginLeft: "8px" }}
                onClick={!addingOrEditing ? this.addNewAccount : null}>Add New</span>

            {(bankAccounts.length > 0 || newAccount) && <table className="table">
                <thead>
                    <tr className="table-header table-row">
                        <th>Routing Number</th>
                        <th>Account Number</th>
                        <th>Account Type</th>
                        <th>Active</th>
                        <th />
                    </tr>
                </thead>
                <tbody>
                    {bankAccounts.map((acct, index) =>
                        editAccountIndex === index
                            ? <tr key={index}>
                                <td>
                                    <ValidatedInput input={<NumberFormat placeholder="#########" format="#########"
                                        onValueChange={(values) => this.updateNewAccount('achRoutingNumber', values.value)} />}
                                        label="ACH Routing Number" name="achRoutingNumber"
                                        value={accountUpdate.achRoutingNumber || ''}
                                        errorMessage="Invalid ACH Routing Number"
                                        validated={true} showValidationError={true}
                                        validate={val => this.validateFieldLength('achRoutingNumber', 9, val)} />
                                </td>
                                <td>
                                    <ValidatedInput input={<NumberFormat placeholder="###############" format="###############"
                                        onValueChange={(values) => this.updateNewAccount('achAccountNumber', values.value)} />}
                                        label="ACH Account Number" name="achAccountNumber"
                                        value={accountUpdate.achAccountNumber || ''} />
                                </td>
                                <td>
                                    <ValidatedInput 
                                        input={<Select tabIndex={430} options={[{ key: 'checking', value: 'checking'}, { key: 'savings', value: 'savings'}]} />}
                                        label="Account Type" 
                                        name="achAccountType" 
                                        value={accountUpdate.achAccountType || ''}
                                        onChange={this.updateNewAccount} />
                                </td>
                                <td>
                                    <Toggle 
                                        id={`active-${index}`}
                                        name="active" 
                                        value={accountUpdate.active}
                                        onChange={this.updateNewAccount} />
                                </td>
                                <td>
                                    <span className={`link-text small-text ${disableSubmit ? "disabled" : ""}`} onClick={!disableSubmit ? this.submitAccountUpdates : null}>Submit</span>
                                    <span className="link-text small-text" onClick={() => this.setState(this.initialState)} style={{ marginLeft: "16px" }}>Cancel</span>
                                </td>
                            </tr>
                            : <tr key={index}>
                                <td className={`${acct.active && submitAttempted && !acct.achRoutingNumber ? "required-err-cell" : ""}`}>{acct.achRoutingNumber}</td>
                                <td className={`${acct.active && submitAttempted && !acct.achAccountNumber ? "required-err-cell" : ""}`}>{acct.achAccountNumber}</td>
                                <td>{acct.achAccountType}</td>
                                <td>
                                    <Toggle
                                        name="active"
                                        id={`edit-active-${index}`}
                                        disabled={addingOrEditing}
                                        onChange={(name, value) => this.toggleAccountActive(index, value)}
                                        value={(addingOrEditing && accountUpdate.active) ? false : acct.active} />
                                </td>
                                <td>
                                    <i className={`icon-pencil primary-hover input ${newAccount ? "disabled" : ""}`}
                                        onClick={!newAccount ? () => this.setState({
                                            editAccountIndex: index,
                                            accountUpdate: acct
                                        }) : null}></i>
                                </td>
                            </tr>
                    )}
                    {newAccount && <tr key="new-acct">
                        <td>
                            <ValidatedInput input={<NumberFormat placeholder="#########" format="#########"
                                onValueChange={(values) => this.updateNewAccount('achRoutingNumber', values.value)} />}
                                label="ACH Routing Number" name="achRoutingNumber"
                                value={accountUpdate.achRoutingNumber}
                                errorMessage="Invalid ACH Routing Number"
                                validated={true} showValidationError={true}
                                validate={val => this.validateFieldLength('achRoutingNumber', 9, val)} />
                        </td>
                        <td>
                            <ValidatedInput input={<NumberFormat placeholder="###############" format="###############"
                                onValueChange={(values) => this.updateNewAccount('achAccountNumber', values.value)} />}
                                label="ACH Account Number" 
                                name="achAccountNumber"
                                value={accountUpdate.achAccountNumber} />
                        </td>
                        <td>
                            <ValidatedInput 
                                input={<Select tabIndex={430} options={[{ key: 'checking', value: 'checking'}, { key: 'savings', value: 'savings'}]} />}
                                label="Account Type" 
                                name="achAccountType" 
                                value={accountUpdate.achAccountType}
                                onChange={this.updateNewAccount} />
                        </td>
                        <td>
                            <Toggle
                                id="new-active"
                                name="active"
                                value={accountUpdate.active}
                                onChange={this.updateNewAccount} />
                        </td>
                        <td>
                            <span className={`link-text small-text ${disableSubmit ? "disabled" : ""}`} onClick={!disableSubmit ? this.submitNewAccount : null}>Submit</span>
                            <span className="link-text small-text" onClick={() => this.setState(this.initialState)} style={{ marginLeft: "16px" }}>Cancel</span>
                        </td>
                    </tr>}
                </tbody>
            </table>}
        </div>
    }
}


// WEBPACK FOOTER //
// ./src/components/recipientAccountsComponents/recipientAccountDetails/AchAccountsTable.jsx